const AdyenCheckout = require('@adyen/adyen-web');
const progress = require('../../../utils/progress');

/**
 * Initialize the web component checkout
 * https://docs.adyen.com/online-payments/3d-secure/native-3ds2/web-component/?tab=create-new-component_2
 *
 * @param {Element} componentContainer - Web component container
 */
function initAdyenComponent(componentContainer) {
    const {clientKey, wcactionJson, environment} = componentContainer.dataset;
    const $paymentCompleteForm = $('#paymentCompleteForm');
    const $detailsInput = $paymentCompleteForm.find('input[name="details"]');
    let wcAction = null;
    try {
        wcAction = JSON.parse(wcactionJson);
    } catch (error) {
        // not showing this to the client
    }
    /**
     * We will get our details here
     *
     * @param {Object} state - component state
     * @param {Object} _component - component itself
     */
    // eslint-disable-next-line no-unused-vars
    function handleOnAdditionalDetails(state, _component) {
        $detailsInput.val(JSON.stringify(state.data.details));
        progress.show($('.main-wrapper'));
        $paymentCompleteForm.trigger('submit');
    }

    if (!wcAction || !clientKey) {
        return;
    }

    const configuration = {
        locale: window.Constants.LOCALE,
        environment,
        clientKey,
        onAdditionalDetails: handleOnAdditionalDetails
    };

    AdyenCheckout(configuration).then(checkout => {
        checkout.createFromAction(wcAction).mount(componentContainer);
    });
}

/**
 * Attach to #js-adyen-component-checkout
 */
exports.init = () => {
    const container = $('#js-adyen-component-checkout');
    if (container.length === 0) {
        return;
    }
    initAdyenComponent(container[0]);
};
